<ion-card [languageRouter]="['evento', event.eventUrl]">
  <div class="event-image-container">
    <img loading="lazy" src="{{ event.data.header }}" alt="{{ event.title }}" />
  </div>
  <ion-card-content>
    <ion-note class="label">{{ 'EVENT_CATEGORIES.' + event.category | uppercase | translate }} <span
        *ngIf="event.shop">| {{event.shop.name}}</span></ion-note>

    <h5 class="event-title">{{ event.data.title }}</h5>

    <ion-card-subtitle>
      <span *ngIf="event.data.timeTable">{{ event.data.timeTable }}</span>
      <span *ngIf="!event.data.timeTable && event.data.shop">{{ event.shop.shopHours}}</span>
    </ion-card-subtitle>

  </ion-card-content>
</ion-card>
